import { useEffect, useState, useRef } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

function PaymentModal({ onClose, onShowHowTo }: { onClose: () => void; onShowHowTo: () => void }) {
  const [copied, setCopied] = useState(false);
  const [messageCopied, setMessageCopied] = useState(false);
  const [selectedPack, setSelectedPack] = useState<'core' | 'double'>('double');
  const [depositorName, setDepositorName] = useState('');
  const [showComplete, setShowComplete] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);

  const vatRate = 1;

  const coreBasePrice = 168000;
  const doubleBasePrice = 278000;

  const packs = {
    core: {
      id: 'core',
      name: '왕초보→중급 속성',
      subtitle: '2개월 집중',
      label: '입문',
      badge: null,
      monthlyPrice: coreBasePrice,
      totalPrice: coreBasePrice,
      vatPrice: Math.round(coreBasePrice * 1.1),
      months: 2,
      discount: null,
      color: 'teal',
      icon: 'ri-seedling-line',
      duration: '첫 발송부터 2개월간 열람',
      versions: [
        {
          vol: '📚 매달 15개 콘텐츠 제공 · 총 30개 · 2개월 과정',
          open: '결제 확인 후 콘텐츠 링크 발송 (밤 12시 전후 기준)',
          duration: '첫 발송부터 2개월간 열람 가능',
        },
        {
          vol: '🎤 숙제: 쉐도잉 녹음 → 카카오 채널 제출',
          open: '매 회차 학습 후 핵심 표현을 따라 말하며 녹음 → 카카오 채널로 전송',
          duration: '매달 꾸준히 완수하면 실력이 쑥쑥!',
        },
      ],
      features: ['매달 15개 콘텐츠 링크 제공 (총 30개)', '밤 12시 전후 기준 발송', '첫 발송부터 2개월간 열람 가능', '쉐도잉 녹음 → 카카오 채널 제출'],
    },
    double: {
      id: 'double',
      name: '중급→고급 점프',
      subtitle: '3개월 집중',
      label: '추천',
      badge: '추천',
      monthlyPrice: doubleBasePrice,
      totalPrice: doubleBasePrice,
      vatPrice: Math.round(doubleBasePrice * 1.1),
      months: 3,
      discount: null,
      color: 'orange',
      icon: 'ri-fire-line',
      duration: '첫 발송부터 3개월간 열람',
      versions: [
        {
          vol: '📚 매달 15개 콘텐츠 제공 · 총 45개 · 3개월 과정',
          open: '결제 확인 후 콘텐츠 링크 발송 (밤 12시 전후 기준)',
          duration: '첫 발송부터 3개월간 열람 가능',
        },
        {
          vol: '🎤 숙제: 쉐도잉 녹음 → 카카오 채널 제출',
          open: '매 회차 학습 후 핵심 표현을 따라 말하며 녹음 → 카카오 채널로 전송',
          duration: '매달 꾸준히 완수하면 실력이 쑥쑥!',
        },
      ],
      features: ['매달 15개 콘텐츠 링크 제공 (총 45개)', '밤 12시 전후 기준 발송', '첫 발송부터 3개월간 열람 가능', '쉐도잉 녹음 → 카카오 채널 제출'],
    },
  };

  const selected = packs[selectedPack];
  const formattedVatPrice = `₩${selected.vatPrice.toLocaleString()}`;
  const formattedMonthlyPrice = `₩${selected.monthlyPrice.toLocaleString()}`;
  const formattedTotalPrice = `₩${selected.totalPrice.toLocaleString()}`;

  const colorMap: Record<string, { border: string; bg: string; text: string; badge: string; btn: string; ring: string }> = {
    teal:   { border: 'border-teal-500',   bg: 'bg-teal-500/10',   text: 'text-teal-400',   badge: 'bg-teal-500 text-white',   btn: 'from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700', ring: 'ring-teal-500' },
    orange: { border: 'border-orange-500', bg: 'bg-orange-500/10', text: 'text-orange-400', badge: 'bg-orange-500 text-white', btn: 'from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600', ring: 'ring-orange-500' },
    amber:  { border: 'border-amber-400',  bg: 'bg-amber-500/10',  text: 'text-amber-400',  badge: 'bg-amber-400 text-black',  btn: 'from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600', ring: 'ring-amber-400' },
  };

  const handleCopy = () => {
    navigator.clipboard.writeText('110621532440');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto px-4 pt-6">
        <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose}></div>
        <div ref={modalRef} className="relative bg-[#111111] border border-gray-700 rounded-2xl w-full max-w-lg shadow-2xl overflow-hidden my-6">

          <div className="sticky top-0 z-10 bg-gradient-to-r from-teal-500 to-teal-600 px-6 py-5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-bank-card-line text-white text-lg"></i>
                </div>
                <div>
                  <h2 className="text-white font-bold text-lg leading-tight">수강 신청 안내</h2>
                  <p className="text-teal-100 text-sm">무통장 입금으로 간편하게 시작하세요</p>
                </div>
              </div>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center text-white/70 hover:text-white transition-colors cursor-pointer">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            <div className="mt-3 bg-white/20 border border-white/30 rounded-xl px-4 py-3 flex items-center justify-center gap-3">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-vip-crown-2-line text-white text-base"></i>
              </div>
              <div className="text-center">
                <p className="text-white font-black text-xl tracking-wide">LEXO 영어 Basic 플랜</p>
                <p className="text-teal-100 text-sm font-medium">현재 구매 가능한 플랜</p>
              </div>
            </div>

            <div className="mt-2 flex flex-col gap-1.5">
              <div className="flex items-center gap-2 bg-white/15 rounded-lg px-3 py-2">
                <i className="ri-lock-line text-teal-100 text-sm flex-shrink-0"></i>
                <p className="text-teal-400 text-sm leading-snug">Smart · Pro 플랜은 준비 중입니다.</p>
              </div>
              <div className="flex items-center gap-2 bg-orange-500/30 border border-orange-400/40 rounded-lg px-3 py-2">
                <i className="ri-price-tag-3-line text-orange-300 text-sm flex-shrink-0"></i>
                <p className="text-orange-100 text-sm leading-snug">
                  <span className="font-black text-white">모든 가격은 부가세(VAT 10%) 별도</span>입니다. 최종 결제 금액은 부가세 포함 금액으로 안내됩니다.
                </p>
              </div>
              <div className="flex items-center gap-2 bg-red-500/20 border border-red-400/30 rounded-lg px-3 py-2">
                <i className="ri-error-warning-line text-red-300 text-sm flex-shrink-0"></i>
                <p className="text-red-100 text-sm leading-snug">
                  <span className="font-black text-white">플랜 변경은 불가합니다.</span> 신중하게 선택해 주세요.
                </p>
              </div>
            </div>
          </div>

          <div className="px-6 py-5 space-y-4">

            <div>
              <p className="text-gray-300 font-semibold text-base flex items-center gap-2 mb-3">
                <i className="ri-gift-line text-teal-400"></i>
                패키지 선택
              </p>
              <div className="grid grid-cols-2 gap-2">
                {(Object.values(packs) as typeof packs[keyof typeof packs][]).map((pack) => {
                  const c = colorMap[pack.color];
                  const isSelected = selectedPack === pack.id;
                  return (
                    <button
                      key={pack.id}
                      onClick={() => setSelectedPack(pack.id as 'core' | 'double')}
                      className={`relative flex flex-col items-center justify-center py-4 px-2 rounded-xl border-2 transition-all duration-200 cursor-pointer ${
                        isSelected ? `${c.border} ${c.bg}` : 'border-gray-700 bg-white/5 hover:border-gray-500'
                      }`}
                    >
                      {pack.badge && (
                        <span className={`absolute -top-2.5 left-1/2 -translate-x-1/2 text-xs font-black px-2 py-0.5 rounded-full whitespace-nowrap ${c.badge}`}>
                          {pack.badge}
                        </span>
                      )}
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${c.bg} border ${c.border}`}>
                        <i className={`${pack.icon} text-xl`}></i>
                      </div>
                      <span className={`font-bold text-sm text-center leading-tight mt-1 ${isSelected ? 'text-white' : 'text-gray-400'}`}>{pack.name}</span>
                      <span className={`text-xs font-bold mt-0.5 ${isSelected ? c.text : 'text-gray-600'}`}>{pack.subtitle}</span>
                      <span className={`text-xs mt-1 font-semibold ${isSelected ? 'text-white' : 'text-gray-500'}`}>
                        ₩{pack.totalPrice.toLocaleString()}
                      </span>
                      <span className={`text-[10px] mt-0.5 ${isSelected ? 'text-gray-400' : 'text-gray-600'}`}>부가세 별도</span>
                    </button>
                  );
                })}
              </div>
            </div>

            <div className={`rounded-xl border ${colorMap[selected.color].border} ${colorMap[selected.color].bg} p-4`}>
              <div className="flex items-center gap-2 mb-3">
                <i className={`${selected.icon} ${colorMap[selected.color].text} text-lg`}></i>
                <span className={`font-bold text-base ${colorMap[selected.color].text}`}>{selected.name} {selected.subtitle}</span>
                <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${colorMap[selected.color].badge}`}>{selected.label}</span>
              </div>

              <div className="space-y-2">
                {selected.versions.map((v, i) => (
                  <div key={i} className="bg-black/30 rounded-lg px-3 py-2.5 flex items-start gap-2.5">
                    <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${colorMap[selected.color].bg} border ${colorMap[selected.color].border}`}>
                      <span className={`text-xs font-black ${colorMap[selected.color].text}`}>{i + 1}</span>
                    </div>
                    <div>
                      <p className="text-white text-sm font-bold mb-0.5">{v.vol}</p>
                      <p className="text-gray-400 text-sm leading-relaxed">{v.open}</p>
                      <p className={`text-sm font-semibold mt-0.5 ${colorMap[selected.color].text}`}>{v.duration}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-teal-500/10 border border-teal-500/30 rounded-xl p-4">
              <div className="flex items-center justify-between mb-3">
                <p className="text-gray-400 text-sm">결제 금액 안내</p>
                <span className="text-xs font-bold text-gray-400 bg-white/10 border border-gray-600 px-2 py-0.5 rounded-full whitespace-nowrap">
                  <i className="ri-information-line mr-1"></i>부가세 별도 기준
                </span>
              </div>

              <div className="space-y-1.5 mb-3">
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">수강료 <span className="text-gray-600 text-xs">(부가세 별도)</span></span>
                  <span className="text-gray-300 text-sm font-semibold">{formattedTotalPrice}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">부가세 (VAT 10%)</span>
                  <span className="text-gray-300 text-sm font-semibold">+₩{Math.round(selected.totalPrice * 0.1).toLocaleString()}</span>
                </div>
              </div>

              <div className="border-t border-teal-500/20 pt-3">
                <div className="flex items-baseline justify-between flex-wrap gap-2">
                  <span className={`font-bold text-base ${colorMap[selected.color].text}`}>최종 입금 금액 <span className="text-xs text-gray-400 font-normal">(VAT 포함)</span></span>
                  <span className="text-3xl font-black text-white">{formattedVatPrice}</span>
                </div>
                <p className="text-teal-400/70 text-xs mt-1.5 flex items-center gap-1">
                  <i className="ri-information-line text-xs"></i>
                  부가세(VAT 10%) 포함 최종 입금 금액
                </p>
              </div>
            </div>

            <div className="bg-white/5 rounded-xl p-4 space-y-3">
              <p className="text-gray-300 font-semibold text-base flex items-center gap-2">
                <i className="ri-bank-line text-teal-400"></i>
                입금 계좌 정보
              </p>
              <div className="space-y-2.5">
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">은행</span>
                  <span className="text-white text-sm font-semibold">신한은행</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">예금주</span>
                  <span className="text-white text-sm font-semibold">이송희</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">계좌번호</span>
                  <div className="flex items-center gap-2">
                    <span className="text-white text-sm font-semibold tracking-wide">110621532440</span>
                    <button
                      onClick={handleCopy}
                      className="flex items-center gap-1 bg-teal-500/20 hover:bg-teal-500/30 text-teal-400 text-xs px-2 py-1 rounded-md transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className={copied ? 'ri-check-line' : 'ri-file-copy-line'}></i>
                      {copied ? '복사됨' : '복사'}
                    </button>
                  </div>
                </div>
              </div>

              <div className="pt-2 border-t border-gray-700/50">
                <label className="text-gray-400 text-sm mb-1.5 block flex items-center gap-1">
                  <i className="ri-user-line text-teal-400"></i>
                  입금자명
                </label>
                <input
                  type="text"
                  value={depositorName}
                  onChange={(e) => setDepositorName(e.target.value)}
                  placeholder="입금자 이름을 입력하세요"
                  className="w-full bg-[#0F0F0F] border border-gray-700 focus:border-teal-500 rounded-lg px-3 py-2.5 text-white text-sm placeholder-gray-600 focus:outline-none transition-colors"
                />
              </div>
            </div>

            <div className="space-y-2">
              <p className="text-gray-300 font-semibold text-base flex items-center gap-2">
                <i className="ri-list-ordered text-teal-400"></i>
                진행 순서
              </p>
              <div className="space-y-2">
                {[
                  { step: '1', text: `위 계좌로 ${formattedVatPrice} 입금 (VAT 포함)`, icon: 'ri-bank-card-line' },
                  { step: '2', text: 'LEXO 영어 카카오톡 채널 추가 후 입금 완료 연락', icon: 'ri-kakao-talk-fill' },
                  { step: '3', text: '확인 후 밤 12시 전후 기준으로 콘텐츠 링크 발송', icon: 'ri-notion-fill' },
                ].map((item) => (
                  <div key={item.step} className="flex items-center gap-3 bg-white/5 rounded-lg px-3 py-3">
                    <div className="w-6 h-6 bg-teal-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white text-xs font-bold">{item.step}</span>
                    </div>
                    <span className="text-gray-300 text-sm">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-[#FEE500]/10 border border-[#FEE500]/30 rounded-xl p-4">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <i className="ri-kakao-talk-fill text-[#FEE500] text-base"></i>
                  <span className="text-[#FEE500] font-bold text-sm">카카오톡 채널 입금 안내 메시지 예시</span>
                </div>
                <button
                  onClick={() => {
                    const msg = `안녕하세요! LEXO 영어 수강 신청합니다 😊\n\n플랜: LEXO 영어 Basic 플랜\n패키지: ${selected.name} ${selected.subtitle}\n수강료: ${formattedTotalPrice} (부가세 별도)\n최종 입금 금액: ${formattedVatPrice} (VAT 10% 포함)\n입금자명: ${depositorName || '(입금자명 입력 후 자동 반영)'}\n\n입금 완료했습니다. 확인 부탁드립니다!`;
                    navigator.clipboard.writeText(msg);
                    setMessageCopied(true);
                    setTimeout(() => setMessageCopied(false), 2000);
                  }}
                  className="flex items-center gap-1 bg-[#FEE500]/20 hover:bg-[#FEE500]/40 text-[#3A1D1D] text-xs px-2.5 py-1 rounded-md transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className={messageCopied ? 'ri-check-line' : 'ri-file-copy-line'}></i>
                  {messageCopied ? '복사됨 ✓' : '메시지 복사'}
                </button>
              </div>
              <div className="bg-black/30 rounded-lg p-3 font-mono text-sm text-gray-200 leading-relaxed whitespace-pre-line">
                {`안녕하세요! LEXO 영어 수강 신청합니다 😊\n\n플랜: LEXO 영어 Basic 플랜\n패키지: ${selected.name} ${selected.subtitle}\n수강료: ${formattedTotalPrice} (부가세 별도)\n최종 입금 금액: ${formattedVatPrice} (VAT 10% 포함)\n입금자명: ${depositorName || '(입금자명 입력 후 자동 반영)'}\n\n입금 완료했습니다. 확인 부탁드립니다!`}
              </div>
              <p className="text-gray-500 text-xs mt-2">* 위 내용을 복사하여 카카오톡 채널에 보내주세요</p>
            </div>

            <a
              href="http://pf.kakao.com/_zgdxhX/chat"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setTimeout(() => setShowComplete(true), 500)}
              className="flex items-center justify-center gap-2 w-full py-4 bg-[#FEE500] hover:bg-[#F5DC00] text-[#3A1D1D] font-bold rounded-xl transition-all duration-300 cursor-pointer whitespace-nowrap text-base"
            >
              <i className="ri-kakao-talk-fill text-lg"></i>
              LEXO 영어 카카오톡 채널 추가하기
            </a>

            <div className="bg-white/5 border border-gray-700/50 rounded-xl p-4 space-y-2">
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-information-line text-gray-400 text-xs"></i>
                <span className="text-gray-400 font-semibold text-xs">환불 정책 및 주의사항</span>
              </div>
              <ul className="space-y-1">
                {[
                  '결제 후 7일 이내, 콘텐츠 미사용 시 환불 가능',
                  '노션 링크 열람 후에는 환불이 불가합니다',
                  '환불 금액은 실제 결제 금액 기준으로 산정됩니다',
                  '부가세(VAT 10%) 및 결제 수수료는 환불되지 않습니다',
                  '이용 기간에 비례하여 잔여 기간분만 환불됩니다 (일할 계산)',
                  '문의: lexojp.help@gmail.com',
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <span className="text-gray-600 text-[10px] mt-0.5 flex-shrink-0">•</span>
                    <span className="text-[11px] leading-relaxed text-gray-500">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <button
              onClick={() => setShowComplete(true)}
              className="w-full flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 border border-gray-600 hover:border-teal-500/50 text-gray-300 hover:text-teal-300 text-sm py-3 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-notification-3-line text-sm"></i>
              Smart Plan · Pro Plan 오픈 알림 신청
              <i className="ri-arrow-right-s-line text-sm"></i>
            </button>
          </div>
        </div>
      </div>

      {showComplete && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
          <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={() => { setShowComplete(false); onClose(); }}></div>
          <div className="relative bg-[#111111] border border-teal-500/40 rounded-2xl w-full max-w-sm shadow-2xl overflow-hidden">
            <div className="h-1.5 bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600"></div>
            <div className="px-4 sm:px-6 py-5 sm:py-8 text-center">
              <div className="relative w-14 h-14 sm:w-20 sm:h-20 mx-auto mb-3 sm:mb-5">
                <div className="absolute inset-0 bg-teal-500/20 rounded-full animate-ping"></div>
                <div className="relative w-14 h-14 sm:w-20 sm:h-20 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center shadow-lg shadow-teal-500/30">
                  <i className="ri-check-line text-white text-2xl sm:text-3xl"></i>
                </div>
              </div>
              <h3 className="text-white font-black text-lg sm:text-xl mb-1.5 sm:mb-2">수강 신청 완료! 🎉</h3>
              <p className="text-teal-400 font-semibold text-xs sm:text-sm mb-3 sm:mb-5">LEXO 영어와 함께 강해지세요!</p>

              <div className="bg-gradient-to-br from-teal-500/20 to-teal-600/10 border-2 border-teal-500/50 rounded-xl sm:rounded-2xl p-3 sm:p-4 mb-3 sm:mb-5 text-left">
                <p className="text-teal-400 text-xs font-bold uppercase tracking-widest mb-2 sm:mb-3 text-center">선택하신 플랜 &amp; 옵션</p>
                <div className="flex flex-col items-center gap-1.5 sm:gap-2">
                  <div className="flex items-center gap-2">
                    <i className="ri-vip-crown-2-line text-teal-400 text-base sm:text-lg"></i>
                    <span className="text-white font-black text-base sm:text-xl">LEXO 영어 Basic 플랜</span>
                  </div>
                  <div className={`flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl ${colorMap[selected.color].bg} border ${colorMap[selected.color].border}`}>
                    <i className={`${selected.icon} ${colorMap[selected.color].text} text-sm sm:text-base`}></i>
                    <span className={`font-black text-sm sm:text-base ${colorMap[selected.color].text}`}>{selected.name}</span>
                    <span className={`text-xs sm:text-sm font-bold ${colorMap[selected.color].text} opacity-80`}>{selected.subtitle}</span>
                    <span className={`text-xs font-black px-1.5 sm:px-2 py-0.5 rounded-full ${colorMap[selected.color].badge}`}>{selected.label}</span>
                  </div>
                  <div className="flex items-center gap-1.5 mt-0.5 sm:mt-1">
                    <i className="ri-time-line text-gray-400 text-xs"></i>
                    <span className="text-gray-300 text-xs sm:text-sm font-semibold">{selected.duration}</span>
                  </div>
                </div>
              </div>

              <div className="bg-white/5 rounded-xl p-3 sm:p-4 mb-3 sm:mb-5 text-left space-y-1.5 sm:space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-xs sm:text-sm">입금 금액</span>
                  <span className="text-teal-400 text-sm sm:text-base font-black">{formattedVatPrice}</span>
                </div>
                {depositorName && (
                  <div className="flex justify-between items-center">
                    <span className="text-gray-500 text-xs sm:text-sm">입금자명</span>
                    <span className="text-white text-xs sm:text-sm font-semibold">{depositorName}</span>
                  </div>
                )}
              </div>
              <div className="bg-teal-500/10 border border-teal-500/30 rounded-xl p-3 sm:p-4 mb-3 sm:mb-5 text-left">
                <p className="text-teal-400 font-bold text-xs sm:text-sm mb-1.5 sm:mb-2 flex items-center gap-1.5">
                  <i className="ri-arrow-right-circle-line"></i>
                  다음 단계
                </p>
                <ol className="space-y-1.5 sm:space-y-2">
                  <li className="flex items-start gap-2 text-gray-300 text-xs sm:text-sm">
                    <span className="text-teal-500 font-bold flex-shrink-0">1.</span>
                    신한은행 <span className="text-white font-semibold">110621532440</span> (이송희)으로 입금
                  </li>
                  <li className="flex items-start gap-2 text-gray-300 text-xs sm:text-sm">
                    <span className="text-teal-500 font-bold flex-shrink-0">2.</span>
                    카카오톡 채널에 입금 완료 메시지 전송
                  </li>
                  <li className="flex items-start gap-2 text-gray-300 text-xs sm:text-sm">
                    <span className="text-teal-500 font-bold flex-shrink-0">3.</span>
                    확인 후 <span className="text-teal-400 font-semibold">밤 12시 전후</span> 콘텐츠 링크 발송!
                  </li>
                </ol>
              </div>
              <p className="text-gray-500 text-xs mb-3 sm:mb-5">
                문의: <span className="text-gray-400">lexojp.help@gmail.com</span>
              </p>
              <button
                onClick={() => { setShowComplete(false); onClose(); }}
                className="w-full bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white font-bold py-3 sm:py-3.5 rounded-xl text-sm sm:text-base transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                확인했습니다 👍
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function HowToModal({ onClose }: { onClose: () => void }) {
  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center overflow-y-auto pt-12 pb-8 px-4">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-[#111111] border border-gray-700 rounded-2xl w-full max-w-2xl shadow-2xl overflow-hidden">
        <div className="bg-gradient-to-r from-teal-500 to-teal-600 px-6 py-5 flex items-center justify-between sticky top-0 z-10">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-route-line text-white text-lg"></i>
            </div>
            <div>
              <h2 className="text-white font-bold text-lg leading-tight">자세한 진행방식</h2>
              <p className="text-teal-100 text-sm">결제부터 숙제 제출까지 한눈에</p>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center text-white/70 hover:text-white transition-colors cursor-pointer">
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="px-6 py-6">
          <div className="relative">
            <div className="absolute left-[19px] top-8 bottom-8 w-0.5 bg-gradient-to-b from-teal-500/60 via-teal-500/30 to-teal-500/10 z-0"></div>

            <div className="space-y-5 relative z-10">

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center shadow-lg shadow-teal-500/30">
                  <i className="ri-bank-card-line text-white text-base"></i>
                </div>
                <div className="flex-1 bg-white/5 border border-gray-800 hover:border-teal-500/40 rounded-xl p-4 transition-all duration-300">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-teal-400 text-xs font-bold bg-teal-500/10 px-2 py-0.5 rounded-full whitespace-nowrap">STEP 1</span>
                    <h3 className="text-sm font-bold text-white">수강료 송금</h3>
                  </div>
                  <p className="text-gray-400 text-xs leading-relaxed mb-2">신한은행 계좌로 수강료를 입금합니다.</p>
                  <div className="bg-black/30 rounded-lg px-3 py-2.5 space-y-1.5">
                    <div className="flex items-center gap-2">
                      <i className="ri-bank-line text-teal-400 text-xs flex-shrink-0"></i>
                      <span className="text-gray-300 text-xs">신한은행 <span className="text-white font-semibold">110621532440</span> (예금주: 이송희)</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-information-line text-teal-400 text-xs flex-shrink-0"></i>
                      <span className="text-gray-300 text-xs">입금자명을 본인 이름으로 정확히 입력해주세요</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-[#FEE500] to-[#FEE500] rounded-full flex items-center justify-center shadow-lg shadow-yellow-500/20">
                  <i className="ri-kakao-talk-fill text-[#3A1D1D] text-base"></i>
                </div>
                <div className="flex-1 bg-white/5 border border-gray-800 hover:border-yellow-500/40 rounded-xl p-4 transition-all duration-300">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-yellow-400 text-xs font-bold bg-yellow-500/10 px-2 py-0.5 rounded-full whitespace-nowrap">STEP 2</span>
                    <h3 className="text-sm font-bold text-white">카카오 채널 추가 &amp; 입금 알림</h3>
                  </div>
                  <p className="text-gray-400 text-xs leading-relaxed mb-2">LEXO 영어 카카오 채널을 추가하고, 입금 완료 메시지를 보내주세요.</p>
                  <div className="bg-[#FEE500]/10 border border-[#FEE500]/20 rounded-lg px-3 py-2.5 space-y-1.5">
                    <div className="flex items-start gap-2">
                      <i className="ri-chat-1-line text-yellow-400 text-xs flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-300 text-xs">카카오톡에서 <span className="text-white font-semibold">"LEXO 영어"</span> 채널 검색 후 추가</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <i className="ri-message-2-line text-yellow-400 text-xs flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-300 text-xs">채널에 <span className="text-white font-semibold">이름 / 선택 플랜 / 입금 금액</span>을 메시지로 전송</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <i className="ri-time-line text-yellow-400 text-xs flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-300 text-xs">입금 확인은 영업일 기준으로 처리됩니다</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-gray-600 to-gray-700 rounded-full flex items-center justify-center shadow-lg shadow-gray-500/20">
                  <i className="ri-links-line text-white text-base"></i>
                </div>
                <div className="flex-1 bg-white/5 border border-gray-800 hover:border-gray-500/40 rounded-xl p-4 transition-all duration-300">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-gray-300 text-xs font-bold bg-white/10 px-2 py-0.5 rounded-full whitespace-nowrap">STEP 3</span>
                    <h3 className="text-sm font-bold text-white">콘텐츠 링크 수신</h3>
                  </div>
                  <p className="text-gray-400 text-xs leading-relaxed mb-2">
                    입금 확인 후 <span className="text-teal-400 font-semibold">밤 12시 전후</span>를 기준으로 콘텐츠 링크를 발송해드립니다.
                  </p>
                  <div className="bg-black/30 rounded-lg px-3 py-2.5 space-y-1.5 mb-3">
                    <div className="flex items-center gap-2">
                      <i className="ri-links-line text-gray-300 text-xs flex-shrink-0"></i>
                      <span className="text-gray-300 text-xs">카카오 채널로 <span className="text-white font-semibold">콘텐츠 페이지 링크</span>가 전송됩니다</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-file-list-3-line text-gray-300 text-xs flex-shrink-0"></i>
                      <span className="text-gray-300 text-xs">콘텐츠 페이지에는 <span className="text-white font-semibold">유튜브 영상 링크 + 핵심 표현 + 대사</span>가 정리되어 있습니다</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-lock-unlock-line text-gray-300 text-xs flex-shrink-0"></i>
                      <span className="text-gray-300 text-xs">링크는 열람 시작일부터 구독 기간 동안 유효합니다</span>
                    </div>
                  </div>
                  <div className="rounded-xl overflow-hidden border border-gray-700/60">
                    <div className="bg-gray-800/80 px-3 py-2 flex items-center gap-3 border-b border-gray-700/60">
                      <div className="flex gap-1.5">
                        <div className="w-2 h-2 rounded-full bg-red-500/70"></div>
                        <div className="w-2 h-2 rounded-full bg-yellow-500/70"></div>
                        <div className="w-2 h-2 rounded-full bg-green-500/70"></div>
                      </div>
                      <div className="flex-1 bg-gray-700/60 rounded-md px-2 py-1 flex items-center gap-1.5">
                        <i className="ri-links-line text-gray-400 text-xs"></i>
                        <span className="text-gray-400 text-xs">LEXO 영어 학습 자료</span>
                      </div>
                    </div>
                    <div className="relative w-full" style={{ height: '160px' }}>
                      <img
                        src="https://public.readdy.ai/ai/img_res/053ed857be27a7d072a8161d360b0989.jpg"
                        alt="학습 링크 페이지 예시"
                        className="w-full h-full object-cover object-top"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                      <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
                        <div className="flex items-center gap-1.5 bg-black/60 backdrop-blur-sm rounded-lg px-2 py-1">
                          <i className="ri-eye-line text-teal-400 text-xs"></i>
                          <span className="text-white text-xs font-semibold">콘텐츠 페이지 예시</span>
                        </div>
                        <div className="flex gap-1">
                          <div className="bg-black/60 backdrop-blur-sm rounded-lg px-2 py-1 flex items-center gap-1">
                            <i className="ri-youtube-fill text-red-400 text-xs"></i>
                            <span className="text-gray-300 text-xs">영상 링크</span>
                          </div>
                          <div className="bg-black/60 backdrop-blur-sm rounded-lg px-2 py-1 flex items-center gap-1">
                            <i className="ri-book-2-line text-teal-400 text-xs"></i>
                            <span className="text-gray-300 text-xs">핵심 표현</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-900/80 px-4 py-2.5 grid grid-cols-3 divide-x divide-gray-700/50">
                      <div className="flex flex-col items-center gap-1 px-2">
                        <i className="ri-youtube-fill text-red-400 text-sm"></i>
                        <span className="text-gray-400 text-xs text-center">유튜브 영상 링크</span>
                      </div>
                      <div className="flex flex-col items-center gap-1 px-2">
                        <i className="ri-translate-2 text-teal-400 text-sm"></i>
                        <span className="text-gray-400 text-xs text-center">핵심 표현 &amp; 대사</span>
                      </div>
                      <div className="flex flex-col items-center gap-1 px-2">
                        <i className="ri-mic-line text-orange-400 text-sm"></i>
                        <span className="text-gray-400 text-xs text-center">쉐도잉 연습</span>
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-600 text-xs mt-1.5 text-center">* 실제 학습 페이지 구성 예시입니다</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center shadow-lg shadow-red-500/20">
                  <i className="ri-youtube-fill text-white text-base"></i>
                </div>
                <div className="flex-1 bg-gradient-to-br from-red-500/10 to-red-600/5 border border-red-500/40 rounded-xl p-4 transition-all duration-300">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-red-400 text-xs font-bold bg-red-500/20 px-2 py-0.5 rounded-full whitespace-nowrap">STEP 4</span>
                    <h3 className="text-sm font-bold text-white">유튜브 영상 &amp; 핵심 표현 학습</h3>
                  </div>
                  <p className="text-gray-300 text-xs leading-relaxed mb-2">영상 링크와 핵심 표현을 확인하고 학습합니다.</p>
                  <div className="bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2.5 space-y-1.5">
                    <div className="flex items-start gap-2">
                      <i className="ri-play-circle-line text-red-400 text-xs flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-300 text-xs"><span className="text-white font-semibold">유튜브 영상</span>을 반복 시청하며 전체 흐름을 파악합니다</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <i className="ri-book-2-line text-red-400 text-xs flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-300 text-xs">정리된 <span className="text-white font-semibold">핵심 표현과 대사</span>를 꼼꼼히 읽고 의미를 파악합니다</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <i className="ri-repeat-line text-red-400 text-xs flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-300 text-xs"><span className="text-white font-semibold">따라 말하기(쉐도잉)</span>를 반복 연습합니다</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-500 rounded-full flex items-center justify-center shadow-lg shadow-teal-500/30">
                  <i className="ri-mic-line text-white text-base"></i>
                </div>
                <div className="flex-1 bg-gradient-to-br from-teal-500/10 to-teal-600/5 border border-teal-500/40 rounded-xl p-4 transition-all duration-300">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-teal-300 text-xs font-bold bg-teal-500/20 px-2 py-0.5 rounded-full whitespace-nowrap">STEP 5</span>
                    <h3 className="text-sm font-bold text-white">쉐도잉 녹음 &amp; 숙제 제출</h3>
                  </div>
                  <p className="text-gray-300 text-xs leading-relaxed mb-2">학습한 내용을 쉐도잉하여 녹음한 뒤, <span className="text-teal-400 font-semibold">카카오 채널로 제출</span>하면 완료!</p>
                  <div className="bg-black/20 rounded-lg px-3 py-2.5 space-y-1.5 mb-2.5">
                    <div className="flex items-start gap-2">
                      <i className="ri-mic-2-line text-teal-400 text-xs flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-300 text-xs">핵심 표현 또는 전체 대사를 <span className="text-white font-semibold">음성 녹음</span>합니다</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <i className="ri-send-plane-line text-teal-400 text-xs flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-300 text-xs"><span className="text-white font-semibold">카카오 채널에 숙제로 전송</span>합니다</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 bg-teal-500/10 rounded-lg px-3 py-2">
                    <i className="ri-checkbox-circle-fill text-teal-400 text-sm flex-shrink-0"></i>
                    <span className="text-teal-300 text-xs font-semibold">매달 꾸준히 완수하면 실력이 쑥쑥 올라갑니다!</span>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <button
            onClick={onClose}
            className="mt-6 w-full bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white font-bold py-3 rounded-xl text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            확인했습니다
          </button>
        </div>
      </div>
    </div>
  );
}

export default function English() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [scrolled, setScrolled] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showHowToModal, setShowHowToModal] = useState(false);

  const handleStartClick = () => {
    setShowPaymentModal(true);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 10);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const englishPlans = [
    {
      id: 'beginner',
      name: '왕초보→중급 2개월 속성',
      price: '₩59,000',
      tag: '입문 추천',
      tagColor: 'teal',
      description: '왕초보부터 시작해 2개월 만에 중급까지 빠르게 끌어올리는 집중 코스',
      features: [
        '유튜브 링크 제공',
        '영상 속 핵심 표현 제공',
        '쉐도잉 숙제 제공',
        '1·2단계 순차 학습',
        '2개월 집중 커리큘럼',
      ],
      popular: false,
      extra: null,
    },
    {
      id: 'intermediate',
      name: '중급',
      price: '₩59,000',
      tag: '추천',
      tagColor: 'orange',
      description: '중급 수준의 실전 영어 표현을 드라마·영화로 집중 학습하는 코스',
      features: [
        '유튜브 링크 제공',
        '영상 속 핵심 표현 제공',
        '쉐도잉 숙제 제공',
        '중급 전용 콘텐츠',
        '실전 회화 중심',
      ],
      popular: true,
      extra: null,
    },
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {showPaymentModal && <PaymentModal onClose={() => setShowPaymentModal(false)} onShowHowTo={() => setShowHowToModal(true)} />}
      {showHowToModal && <HowToModal onClose={() => setShowHowToModal(false)} />}
      <Navbar scrolled={scrolled} customSubtitle="강한 영어" logoHref="/english" />
      
      <section className="relative pt-24 sm:pt-32 pb-12 sm:pb-20 px-4 sm:px-6 overflow-hidden">
        {/* 배경 이미지 */}
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Ultra%20modern%20cinematic%20dark%20studio%20with%20glowing%20teal%20cyan%20light%20beams%20cutting%20through%20smoke%20haze%20abstract%20bokeh%20particles%20floating%20in%20air%20deep%20black%20background%20with%20subtle%20gradient%20neon%20glow%20reflections%20on%20wet%20floor%20premium%20luxury%20editorial%20photography%202025%20trending%20aesthetic%20high%20contrast%20dramatic%20atmosphere&width=1400&height=900&seq=lexo-english-hero-bg-2025-v9&orientation=landscape"
            alt="영어 학습 배경"
            className="w-full h-full object-cover object-center"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/70 via-[#0A0A0A]/50 to-[#0A0A0A]"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/60 via-transparent to-[#0A0A0A]/60"></div>
        </div>

        <div className="absolute inset-0 bg-gradient-to-b from-teal-500/5 via-transparent to-transparent"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-10 sm:mb-16">
            <div className="inline-block bg-gradient-to-r from-teal-500 to-teal-600 text-white px-4 sm:px-6 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-8 whitespace-nowrap">
              개인 학습자용
            </div>
            <h1 className="text-[36px] sm:text-[60px] md:text-[80px] font-bold text-white mb-4 sm:mb-6">
              LEXO 강한 영어 : <span className="bg-gradient-to-r from-teal-400 to-teal-500 bg-clip-text text-transparent">English</span>
            </h1>
            <p className="text-sm sm:text-xl text-gray-300 max-w-3xl mx-auto mb-6 sm:mb-8 px-2">
              컨텐츠는 미국/영국 드라마, 영화 등 랜덤 발송
            </p>
            <button
              onClick={handleStartClick}
              className="bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white font-bold px-8 sm:px-12 py-3 sm:py-4 rounded-xl text-sm sm:text-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              English 플랜 시작하기
            </button>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 px-4 sm:px-6 relative overflow-hidden">
        {/* 배경 */}
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Vibrant%20energetic%20English%20language%20learning%20concept%20bold%20electric%20teal%20neon%20glow%20abstract%20background%20with%20floating%20English%20alphabet%20letters%20words%20phrases%20swirling%20dynamic%20motion%20blur%20dark%20deep%20black%20background%20cinematic%20dramatic%20lighting%20passionate%20intense%20atmosphere%20education%20breakthrough%20moment&width=1400&height=800&seq=lexo-promo-bg-v1&orientation=landscape"
            alt="홍보 배경"
            className="w-full h-full object-cover object-center opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-transparent to-[#0A0A0A]"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/80 via-transparent to-[#0A0A0A]/80"></div>
        </div>

        <div className="max-w-6xl mx-auto relative z-10">
          {/* 상단 뱃지 */}
          <div className="text-center mb-10 sm:mb-16">
            <div className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-500/40 text-teal-300 px-4 sm:px-6 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold mb-5 sm:mb-8 whitespace-nowrap">
              <i className="ri-flashlight-fill"></i>
              LEXO 강한 영어의 비밀
            </div>
            <h2 className="text-3xl sm:text-5xl md:text-6xl font-black text-white leading-tight mb-4 sm:mb-6">
              어느 날 갑자기<br />
              <span className="bg-gradient-to-r from-teal-400 via-teal-300 to-teal-500 bg-clip-text text-transparent">
                영어가 터진다
              </span>
            </h2>
            <p className="text-gray-300 text-sm sm:text-xl max-w-2xl mx-auto leading-relaxed">
              억지로 외우지 않아도, 문법을 몰라도<br className="hidden sm:block" />
              <strong className="text-white">드라마·영화 속 진짜 영어</strong>를 반복하다 보면<br className="hidden sm:block" />
              자기도 모르는 사이에 입이 열립니다.
            </p>
          </div>

          {/* 레벨 여정 카드 */}
          <div className="relative mb-12 sm:mb-20">
            {/* 연결선 */}
            <div className="hidden sm:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-teal-500/20 via-teal-400/60 to-teal-500/20 -translate-y-1/2 z-0"></div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-6 relative z-10">
              {[
                {
                  level: 'LEVEL 1',
                  title: '왕초보',
                  desc: '"Hello"도 떨리던 나',
                  icon: 'ri-seedling-line',
                  color: 'from-gray-600 to-gray-700',
                  textColor: 'text-gray-400',
                  borderColor: 'border-gray-600/50',
                  bgColor: 'bg-gray-800/40',
                  emoji: '😰',
                },
                {
                  level: 'LEVEL 2',
                  title: '중급 진입',
                  desc: '드라마 대사가 들리기 시작',
                  icon: 'ri-ear-line',
                  color: 'from-teal-700 to-teal-600',
                  textColor: 'text-teal-400',
                  borderColor: 'border-teal-600/50',
                  bgColor: 'bg-teal-900/30',
                  emoji: '👂',
                },
                {
                  level: 'LEVEL 3',
                  title: '고급 점프',
                  desc: '자연스럽게 문장이 나온다',
                  icon: 'ri-chat-voice-line',
                  color: 'from-orange-600 to-amber-500',
                  textColor: 'text-orange-400',
                  borderColor: 'border-orange-500/50',
                  bgColor: 'bg-orange-900/20',
                  emoji: '🗣️',
                },
                {
                  level: 'GOAL',
                  title: '네이티브 회화',
                  desc: '원어민과 자유롭게 대화!',
                  icon: 'ri-global-line',
                  color: 'from-yellow-400 to-amber-400',
                  textColor: 'text-yellow-300',
                  borderColor: 'border-yellow-400/60',
                  bgColor: 'bg-yellow-900/20',
                  emoji: '🌟',
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className={`relative flex flex-col items-center text-center rounded-2xl border ${item.borderColor} ${item.bgColor} p-4 sm:p-6 backdrop-blur-sm hover:scale-105 transition-transform duration-300`}
                >
                  {idx === 3 && (
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-yellow-400 to-amber-400 text-black text-[10px] sm:text-xs font-black px-3 py-0.5 rounded-full whitespace-nowrap">
                      🎯 최종 목표
                    </div>
                  )}
                  {/* Fixed className interpolation for gradient color */}
                  <div className={`w-8 h-8 sm:w-12 sm:h-12 bg-gradient-to-br ${item.color} flex items-center justify-center mb-3 sm:mb-4 shadow-lg`}>
                    <span className="text-xl sm:text-2xl">{item.emoji}</span>
                  </div>
                  <span className={`text-[10px] sm:text-xs font-black tracking-widest ${item.textColor} mb-1`}>{item.level}</span>
                  <h3 className="text-white font-black text-sm sm:text-lg mb-1 sm:mb-2">{item.title}</h3>
                  <p className="text-gray-400 text-[11px] sm:text-sm leading-snug">{item.desc}</p>
                  {idx < 3 && (
                    <div className="sm:hidden mt-3 text-teal-400 text-lg">↓</div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* 핵심 메시지 배너 */}
          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Confident%20young%20Asian%20woman%20speaking%20English%20fluently%20with%20American%20native%20speaker%20in%20modern%20cafe%20setting%20warm%20natural%20lighting%20genuine%20smile%20relaxed%20conversation%20body%20language%20open%20friendly%20atmosphere%20real%20life%20English%20conversation%20success%20moment%20candid%20photography&width=1400&height=500&seq=lexo-promo-conv-v1&orientation=landscape"
              alt="네이티브 영어 회화"
              className="w-full h-[200px] sm:h-[400px] object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-black/30"></div>
            <div className="absolute inset-0 flex flex-col justify-center px-6 sm:px-16">
              <div className="max-w-xl">
                <div className="inline-flex items-center gap-2 bg-teal-500/30 border border-teal-400/50 text-teal-300 px-3 sm:px-4 py-1 rounded-full text-[10px] sm:text-xs font-bold mb-3 sm:mb-5 whitespace-nowrap">
                  <i className="ri-sparkling-2-fill"></i>
                  실제 수강생 경험
                </div>
                <h3 className="text-xl sm:text-4xl font-black text-white leading-tight mb-3 sm:mb-5">
                  "공부하는 줄도 몰랐는데<br />
                  <span className="text-teal-400">어느 순간 영어가 나왔어요"</span>
                </h3>
                <p className="text-gray-300 text-xs sm:text-base leading-relaxed mb-4 sm:mb-6">
                  매일 드라마 한 편, 핵심 표현 따라 말하기.<br className="hidden sm:block" />
                  억지로 외우지 않아도 <strong className="text-white">반복이 쌓이면 자연스럽게 입이 열립니다.</strong>
                </p>
                <button
                  onClick={handleStartClick}
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white font-bold px-6 sm:px-10 py-3 sm:py-4 rounded-xl text-sm sm:text-base transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-teal-500/30"
                >
                  <i className="ri-rocket-2-line"></i>
                  나도 지금 시작하기
                </button>
              </div>
            </div>
          </div>

          {/* 숫자로 보는 효과 */}
          <div className="grid grid-cols-3 gap-3 sm:gap-6 mt-6 sm:mt-10">
            {[
              { num: '2개월', label: '왕초보→중급 완성', icon: 'ri-timer-flash-line', color: 'text-teal-400' },
              { num: '15개', label: '매월 제공되는 실전 콘텐츠', icon: 'ri-play-circle-line', color: 'text-orange-400' },
              { num: '100%', label: '드라마·영화 실제 대사', icon: 'ri-film-line', color: 'text-yellow-400' },
            ].map((stat, idx) => (
              <div key={idx} className="bg-white/5 border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:p-6 text-center hover:bg-white/10 transition-all duration-300">
                <div className="w-8 h-8 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-2 sm:mb-3">
                  <i className={`${stat.icon} ${stat.color} text-xl sm:text-3xl`}></i>
                </div>
                <div className={`text-xl sm:text-4xl font-black ${stat.color} mb-1`}>{stat.num}</div>
                <div className="text-gray-400 text-[10px] sm:text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 sm:mb-16">
            <div className="inline-block bg-red-500/20 text-red-400 px-4 sm:px-5 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4 whitespace-nowrap">
              학습 콘텐츠
            </div>
            <h2 className="text-2xl sm:text-4xl font-bold text-white mb-3 sm:mb-4">
              이런 콘텐츠로 배워요
            </h2>
            <p className="text-gray-400 text-sm sm:text-lg">미국/영국 드라마 &amp; 영화</p>
          </div>

          <div className="grid grid-cols-2 gap-3 sm:gap-8">
            <div className="group relative rounded-xl sm:rounded-2xl overflow-hidden" style={{ minHeight: '140px' }}>
              <div className="w-full h-[140px] sm:h-[300px]" style={{ minHeight: '140px' }}>
                <img 
                  src="https://readdy.ai/api/search-image?query=Cinematic%20still%20from%20popular%20American%20TV%20drama%20series%20like%20Friends%20or%20Suits%20elegant%20living%20room%20or%20office%20setting%20warm%20golden%20hour%20lighting%20professional%20actors%20natural%20conversation%20scene%20high%20quality%20production%20detailed%20background&width=600&height=400&seq=lexo-eng-drama-content-v2&orientation=landscape"
                  alt="드라마 콘텐츠"
                  loading="eager"
                  crossOrigin="anonymous"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{ display: 'block', width: '100%', height: '100%' }}
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-6">
                <div className="inline-block bg-pink-500/80 text-white px-2 sm:px-4 py-0.5 sm:py-1.5 rounded-full text-[10px] sm:text-sm font-semibold mb-1 sm:mb-3 whitespace-nowrap">
                  드라마
                </div>
                <h3 className="text-sm sm:text-2xl font-bold text-white mb-0.5 sm:mb-2">인기 미국/영국 드라마</h3>
                <p className="text-gray-300 text-[10px] sm:text-[15px]">
                  <span className="text-teal-400 font-semibold">인기 드라마의 실제 대사로</span> 자연스러운 영어 표현 학습
                </p>
              </div>
            </div>

            <div className="group relative rounded-xl sm:rounded-2xl overflow-hidden" style={{ minHeight: '140px' }}>
              <div className="w-full h-[140px] sm:h-[300px]" style={{ minHeight: '140px' }}>
                <img 
                  src="https://readdy.ai/api/search-image?query=Dramatic%20Hollywood%20blockbuster%20movie%20scene%20cinematic%20wide%20shot%20intense%20lighting%20action%20or%20emotional%20moment%20high%20production%20value%20film%20quality%20dark%20atmospheric%20background%20professional%20cinematography%20epic%20composition&width=600&height=400&seq=lexo-eng-movie-content-v2&orientation=landscape"
                  alt="영화 콘텐츠"
                  loading="eager"
                  crossOrigin="anonymous"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{ display: 'block', width: '100%', height: '100%' }}
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-6">
                <div className="inline-block bg-orange-500/80 text-white px-2 sm:px-4 py-0.5 sm:py-1.5 rounded-full text-[10px] sm:text-sm font-semibold mb-1 sm:mb-3 whitespace-nowrap">
                  영화
                </div>
                <h3 className="text-sm sm:text-2xl font-bold text-white mb-0.5 sm:mb-2">인기 할리우드 영화</h3>
                <p className="text-gray-300 text-[10px] sm:text-[15px]">
                  <span className="text-teal-400 font-semibold">실제 원어민이 사용하는 생생한 회화</span> 표현 학습
                </p>
              </div>
            </div>
          </div>
          
          <p className="text-gray-500 text-xs sm:text-sm text-center mt-4 sm:mt-6">
            * 콘텐츠 내용은 랜덤입니다
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-20 px-4 sm:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 sm:mb-16">
            <h2 className="text-2xl sm:text-4xl font-bold text-white mb-2 sm:mb-4">플랜 선택</h2>
            <p className="text-gray-400 text-sm sm:text-lg">나에게 맞는 플랜을 선택하세요</p>
            <p className="text-gray-500 text-xs sm:text-sm mt-2">* 모든 가격은 부가세(VAT 10%) 별도입니다</p>
          </div>
          
          <div className="flex flex-col gap-5 sm:gap-8">
            <div className="relative bg-[#0A0A0A] rounded-xl sm:rounded-2xl p-5 sm:p-8 border border-teal-500/40">
              <div className="inline-block bg-teal-500/20 text-teal-400 px-3 py-1 rounded-full text-xs font-bold mb-2 whitespace-nowrap">
                입문 추천
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 sm:mb-6">
                <div>
                  <h3 className="text-xl sm:text-3xl font-bold text-white mb-1 sm:mb-2">왕초보→중급 속성</h3>
                  <p className="text-gray-400 text-sm mb-2">왕초보부터 시작해 2개월 만에 중급까지 빠르게 끌어올리는 집중 코스</p>
                  <div className="flex items-baseline gap-1 flex-wrap">
                    <span className="text-2xl sm:text-4xl font-bold text-white">₩168,000</span>
                    <span className="text-gray-500 text-[10px] sm:text-xs ml-1 whitespace-nowrap">부가세 별도</span>
                  </div>
                  <div className="flex items-center gap-2 mt-1 flex-wrap">
                    <span className="text-teal-400 text-xs font-semibold">월 15개 콘텐츠 · 총 30개</span>
                    <span className="text-gray-600 text-xs">|</span>
                    <span className="text-gray-500 text-xs">2개월 과정</span>
                  </div>
                </div>
                <button
                  onClick={handleStartClick}
                  className="mt-3 sm:mt-0 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white font-bold py-3 sm:py-4 px-8 sm:px-10 rounded-xl transition-all duration-300 whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  시작하기
                </button>
              </div>
              <div className="border-t border-gray-800 pt-4 sm:pt-6">
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 sm:gap-3">
                  {['유튜브 링크 제공', '영상 속 핵심 표현 제공', '쉐도잉 숙제 제공', '1·2단계 순차 학습', '2개월 집중 커리큘럼', '월 15개 · 총 30개 콘텐츠 제공'].map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-300">
                      <i className="ri-check-line text-teal-400 text-base sm:text-lg mr-2.5 sm:mr-3 flex-shrink-0"></i>
                      <span className="text-sm sm:text-base leading-snug">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="relative bg-[#0A0A0A] rounded-xl sm:rounded-2xl p-5 sm:p-8 border-2 border-orange-500/60 ring-2 ring-orange-500/30">
              <div className="absolute -top-3 sm:-top-4 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-orange-500 to-amber-500 text-white px-4 sm:px-6 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-semibold whitespace-nowrap z-10">
                추천
              </div>
              <div className="inline-block bg-orange-500/20 text-orange-400 px-3 py-1 rounded-full text-xs font-bold mb-2 whitespace-nowrap">
                중급 이상
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 sm:mb-6">
                <div>
                  <h3 className="text-xl sm:text-3xl font-bold text-white mb-1 sm:mb-2">중급→고급 점프</h3>
                  <p className="text-gray-400 text-sm mb-2">중급에서 고급으로 도약하는 3개월 집중 코스</p>
                  <div className="flex items-baseline gap-1 flex-wrap">
                    <span className="text-2xl sm:text-4xl font-bold text-white">₩278,000</span>
                    <span className="text-gray-500 text-[10px] sm:text-xs ml-1 whitespace-nowrap">부가세 별도</span>
                  </div>
                  <div className="flex items-center gap-2 mt-1 flex-wrap">
                    <span className="text-orange-400 text-xs font-semibold">월 15개 콘텐츠 · 총 45개</span>
                    <span className="text-gray-600 text-xs">|</span>
                    <span className="text-gray-500 text-xs">3개월 과정</span>
                  </div>
                </div>
                <button
                  onClick={handleStartClick}
                  className="mt-3 sm:mt-0 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-bold py-3 sm:py-4 px-8 sm:px-10 rounded-xl transition-all duration-300 whitespace-nowrap cursor-pointer text-sm sm:text-base"
                >
                  시작하기
                </button>
              </div>
              <div className="border-t border-gray-800 pt-4 sm:pt-6">
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 sm:gap-3">
                  {['유튜브 링크 제공', '영상 속 핵심 표현 제공', '쉐도잉 숙제 제공', '고급 전용 콘텐츠', '3개월 집중 커리큘럼', '월 15개 · 총 45개 콘텐츠 제공'].map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-300">
                      <i className="ri-check-line text-orange-400 text-base sm:text-lg mr-2.5 sm:mr-3 flex-shrink-0"></i>
                      <span className="text-sm sm:text-base leading-snug">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="relative bg-[#0A0A0A] rounded-xl sm:rounded-2xl p-5 sm:p-8 border border-gray-700/50 opacity-60">
              <div className="absolute inset-0 rounded-xl sm:rounded-2xl flex items-center justify-center z-10">
                <div className="bg-black/70 backdrop-blur-sm rounded-xl px-6 py-3 flex items-center gap-3 border border-gray-600">
                  <i className="ri-time-line text-gray-300 text-xl"></i>
                  <span className="text-white font-bold text-base">다음 레벨 준비중</span>
                </div>
              </div>
              <div className="inline-block bg-gray-700/40 text-gray-500 px-3 py-1 rounded-full text-xs font-bold mb-2 whitespace-nowrap">
                Coming Soon
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 sm:mb-6">
                <div>
                  <h3 className="text-xl sm:text-3xl font-bold text-gray-600 mb-1 sm:mb-2">다음 레벨</h3>
                  <p className="text-gray-600 text-sm mb-2">더 높은 단계의 영어 실력을 위한 코스</p>
                  <div className="flex items-baseline gap-1">
                    <span className="text-2xl sm:text-4xl font-bold text-gray-600">준비중</span>
                  </div>
                </div>
                <button
                  disabled
                  className="mt-3 sm:mt-0 bg-gray-700/50 text-gray-600 font-bold py-3 sm:py-4 px-8 sm:px-10 rounded-xl whitespace-nowrap cursor-not-allowed text-sm sm:text-base"
                >
                  준비중
                </button>
              </div>
            </div>
          </div>

          <div className="mt-8 sm:mt-10 flex justify-center">
            <button
              onClick={() => setShowHowToModal(true)}
              className="group flex items-center gap-3 bg-white/5 hover:bg-teal-500/10 border border-gray-600 hover:border-teal-500/60 text-gray-300 hover:text-teal-300 px-8 py-4 rounded-2xl transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-teal-500/20 group-hover:bg-teal-500/30 rounded-full transition-colors">
                <i className="ri-route-line text-teal-400 text-base"></i>
              </div>
              <span className="font-semibold text-sm sm:text-base">자세한 진행방식 보기</span>
              <i className="ri-arrow-right-s-line text-sm group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden" style={{ minHeight: '300px' }}>
            <div className="w-full h-[300px] sm:h-[600px]">
              <img
                src="https://readdy.ai/api/search-image?query=Powerful%20motivational%20English%20language%20learning%20banner%20bold%20dynamic%20composition%20with%20bright%20electric%20teal%20and%20white%20energy%20beams%20radiating%20outward%20strong%20confident%20person%20silhouette%20arms%20raised%20victory%20pose%20against%20dramatic%20dark%20background%20with%20glowing%20English%20alphabet%20letters%20floating%20around%20inspiring%20education%20concept&width=1400&height=600&seq=lexo-strong-english-banner-v3&orientation=landscape"
                alt="강한 영어"
                loading="eager"
                crossOrigin="anonymous"
                className="w-full h-full object-cover object-center"
                style={{ display: 'block', width: '100%', height: '100%' }}
                onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6">
              <div className="inline-block bg-teal-600/90 backdrop-blur-sm text-white px-4 sm:px-8 py-1 sm:py-3 rounded-full text-[10px] sm:text-sm font-bold mb-4 sm:mb-6 border-2 border-teal-300 whitespace-nowrap">
                LEXO의 약속
              </div>
              <h2 className="text-3xl sm:text-6xl md:text-8xl font-black text-white mb-3 sm:mb-6 drop-shadow-2xl">
                강한 영어
              </h2>
              <p className="text-gray-300 text-sm sm:text-xl max-w-2xl mx-auto leading-relaxed mb-4 sm:mb-6">
                진짜 실력으로 승부하는 영어 학습
              </p>
              <button
                onClick={handleStartClick}
                className="bg-teal-500 hover:bg-teal-600 text-white font-bold px-6 sm:px-12 py-3 sm:py-5 rounded-xl text-sm sm:text-lg transition-all duration-300 shadow-2xl border-2 border-teal-300 whitespace-nowrap cursor-pointer"
              >
                지금 시작하기
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-4xl font-bold text-white text-center mb-10 sm:mb-16">
            자주 묻는 질문
          </h2>
          <div className="space-y-3 sm:space-y-6">
            {[
              {
                q: '플랜 변경은 되나요?',
                a: '플랜변경은 불가능합니다.'
              },
              {
                q: '환불 정책은 어떻게 되나요?',
                a: '결제 후 7일 이내 콘텐츠 미사용 시 환불 가능합니다. 단, 부가세 및 카드 수수료는 환불되지 않습니다. 콘텐츠를 이용한 경우에는 환불이 불가합니다.'
              },
              {
                q: '어떤 콘텐츠로 학습하나요?',
                a: '미국/영국의 인기 드라마, 영화 등을 랜덤으로 제공하여 다양한 실전 영어를 학습할 수 있습니다.'
              },
              {
                q: '콘텐츠는 언제 발송되나요?',
                a: '정기적으로 발송됩니다. 밤 12시 이전 결제시 영업일 기준 다음날부터, 밤 12시 이후 결제시 영업일 기준 다다음날부터 발송됩니다.'
              },
              {
                q: '문의는 어떻게 하나요?',
                a: '모든 문의 사항은 lexojp.help@gmail.com 으로 연락주시면 신속하게 답변드리겠습니다.'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white/5 backdrop-blur-sm rounded-lg sm:rounded-xl p-4 sm:p-8 hover:bg-white/10 transition-all duration-300">
                <h3 className="text-sm sm:text-lg font-bold text-white mb-2 sm:mb-3">{faq.q}</h3>
                <p className="text-gray-400 text-xs sm:text-base">{faq.a}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 sm:mt-12 bg-white/5 backdrop-blur-sm rounded-xl sm:rounded-2xl p-5 sm:p-8 text-center">
            <div className="w-10 h-10 sm:w-14 sm:h-14 bg-teal-500/20 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-mail-send-line text-teal-400 text-lg sm:text-2xl"></i>
            </div>
            <h3 className="text-base sm:text-xl font-bold text-white mb-2 sm:mb-3">문의 및 환불</h3>
            <p className="text-gray-400 text-sm">문의 사항이나 환불이 필요하신 경우 아래 이메일로 연락해주세요</p>
            <a href="mailto:lexojp.help@gmail.com" className="text-teal-400 font-semibold text-sm hover:text-teal-300 transition-colors">
              lexojp.help@gmail.com
            </a>
            <p className="text-gray-500 text-xs sm:text-sm mt-2">* 환불 시 부가세 및 카드 수수료는 환불되지 않습니다</p>
          </div>
        </div>
      </section>

      <Footer isEnglish={true} />
    </div>
  );
}
